import React from 'react'
import createReactClass from 'create-react-class'

var OpeLoader = createReactClass({

	render: function() {

		var style = {};
		if (this.props.style) {
			style = this.props.style
		}
		var substyle = {};

		if (this.props.size) {
			substyle.width = this.props.size;
			substyle.height = this.props.size;
			substyle.lineHeight = this.props.size;
			substyle.fontSize = this.props.size;
		}

		return (
			<div className="ball-scale-ripple" style={style}>
				<div style={substyle}></div>
			</div>
		);

	}
});

export default OpeLoader;
